import React, { useState } from 'react';
import './DesktopMenu.scss';
import { useNavbarContext } from '../../Navbar';
import { NavList } from '../DesktopList/NavList';
import { NavBrand } from '../../components/NavBrand';
import { NavToggle } from '../../components/NavToggle';

export const DesktopMenu = (props) => {
  const { primaryNav, secondaryNav, activeLinks } = useNavbarContext();
  const [activeItem, setActiveItem] = useState(null);
  const { isOffcanvasOpen = false, onClick, isDesktop } = props;

  return (
    <div
      className={`navbar-navigation ${isOffcanvasOpen ? 'is-open' : ''}`}
      onMouseLeave={()=>{
        setActiveItem(undefined)
      }}
    >
      <div className='navbar-navigation-header'>
        <NavToggle
          onClick={onClick}
          isOffcanvasOpen={isOffcanvasOpen}
        />
        
        <NavBrand
          isOffcanvas={true}
        />
      </div>

      <div className='navbar-navigation-body'>
        <ul className='navbar-navigation-nav secondary'>
          {
            secondaryNav && secondaryNav.map(item => (
              <NavList
                isSecondary={true}
                level={0}
                key={item.title}
                item={item}
                onMouseOver={()=>{
                  isDesktop ? setActiveItem(item) : setTimeout(() => { setActiveItem(item) }, 5)
                }}
                onMouseLeave={()=>{
                  setActiveItem(undefined)
                }}
                isDesktop={isDesktop}
                isSelected={(activeItem && activeItem.title === item.title) || activeLinks.includes(item.link)}
              />
            ))
          }
        </ul>

        <ul className='navbar-navigation-nav primary'>
          {
            primaryNav && primaryNav.map(item => (
              <NavList
                isSecondary={false}
                level={0}
                key={item.title}
                item={item}
                onMouseOver={()=>{
                  isDesktop ? setActiveItem(item) : setTimeout(() => { setActiveItem(item) }, 5)
                }}
                onMouseLeave={()=>{
                  setActiveItem(undefined)
                }}
                isDesktop={isDesktop}
                isSelected={(activeItem && activeItem.title === item.title) || activeLinks.includes(item.link)}
              />
            ))
          }
        </ul>
      </div>
    </div>
  );
};
